import React from "react";
import { Check, Eye, PhoneCall, Star, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function OurStoryMission() {
  const avatars = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/student_learning_1.png",
    alt: "Student 1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/student_learning_2.png",
    alt: "Student 2"
  }];
  return <section data-section-id="258796" id="our-story-mission" className="relative py-24 bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-3xl bg-primary/10 blur-[100px]" />
        <div className="absolute top-[20%] right-[-10%] w-[30%] h-[50%] rounded-3xl bg-chart-2/10 blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div className="flex flex-col gap-6">
            <span className="text-sm font-bold tracking-wider text-primary uppercase font-default">
              Future Ready Australia Ltd
            </span>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-foreground leading-tight tracking-tight">Our Mission</h2>
            
            <p className="text-lg text-muted-foreground leading-relaxed font-default">
              Our mission is to support communities by delivering inclusive, practical and engaging education programs that build skills in technology, creativity, problem-solving and lifelong learning.
            </p>

            <div className="flex flex-wrap gap-4 mt-2">
              <Button size="lg" className="gap-2 rounded-lg bg-primary hover:bg-primary/90 shadow-lg transition-all" asChild>
                <Link to="#spotlight-ai-coding-classes">
                  <PhoneCall className="w-5 h-5" />
                  Our Programs
                </Link>
              </Button>
            </div>

            {}
            <div className="flex items-center gap-6 mt-6">
              <div className="flex -space-x-3">
                {avatars.map((avatar, i) => <div key={i} data-index={i} className="relative z-10">
                    <img src={avatar.src} alt={avatar.alt} className="w-10 h-10 rounded-lg border-2 border-background object-cover" data-wvc-srcset={`${avatar.src}-wvc-srcset`} data-wvc-sizes={`${avatar.src}-wvc-sizes`} loading="lazy" />
                  </div>)}
              </div>
              
              <div className="h-10 w-px bg-border hidden sm:block" />

              <div className="flex items-center gap-3 bg-accent/50 px-4 py-2 rounded-lg border border-accent">
                <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Users className="w-4 h-4 text-primary" />
                </div>
                <div className="flex flex-col">
                  <span className="text-[10px] font-bold text-primary uppercase tracking-widest leading-none font-default">
                    Community
                  </span>
                  <span className="text-sm font-bold text-foreground leading-tight font-default">
                    Impact Driven
                  </span>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="relative mt-10 md:mt-0">
            {}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3] bg-muted border border-border">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/community_education_workshop.png" alt="Children learning coding in a workshop" className="w-full h-full object-cover" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/community_education_workshop.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/community_education_workshop.png-wvc-sizes" loading="lazy" src="https://futurereadyaustralia.org/wp-content/uploads/2026/05/cropped-cropped-Future-Ready-Australia-logo-rectangle-4-2.png" />
            </div>

            {}
            <div className="absolute -top-6 -right-4 md:-right-8 bg-card p-4 rounded-xl shadow-xl border border-border flex flex-col items-center justify-center min-w-[120px]">
              <span className="text-3xl font-bold text-primary font-default">100%</span>
              <span className="text-xs font-semibold text-muted-foreground text-center uppercase tracking-wider mt-1 font-default">
                Not-for-Profit<br />Impact
              </span>
            </div>

            {}
            <div className="absolute -bottom-8 -left-4 md:-left-8 bg-card p-4 rounded-xl shadow-xl border border-border flex items-center gap-4 max-w-[240px]">
              <div className="w-10 h-10 rounded-lg bg-chart-2/10 flex items-center justify-center shrink-0">
                <Check className="w-6 h-6 text-chart-2" />
              </div>
              <div className="flex flex-col">
                <span className="text-[10px] font-bold text-muted-foreground uppercase tracking-wider font-default">
                  Our Mission
                </span>
                <span className="text-sm font-bold text-foreground leading-tight font-default">
                  Future-Focused Education
                </span>
              </div>
            </div>

  
            
          </div>
        </div>
      </div>
    </section>;
}